import { Map } from 'immutable';

import * as types from './types';
import overviewVDCTypes from './../vdc/test-overview/types';
import overviewRDCTypes from './../rdc/test-overview/types';
import testListVDCTypes from './../vdc/test-history/test-list/types';
import testListRDCTypes from './../rdc/test-history/test-list/types';
import * as constants from './constants';

const initialState = Map({
  loading: true,
  errors: Map({
    getTests: null,
    getOrganization: null,
    getMetrics: null,
    getTrendsVDC: null,
    getTrendsRDC: null,
    getErrors: null,
    getTestCasesVDC: null,
    getTestCasesRDC: null,
    getFailureTests: null,
  }),
});

const setError = (state, type, err = null) => state.setIn(['errors', type], err);

const viewReducer = (state = initialState, { type }) => {
  switch (type) {
    case types.LOAD_INIT_DATA.REQUEST:
      return state.set('loading', true);
    case types.LOAD_INIT_DATA.SUCCESS:
      return state.set('loading', false);
    case types.LOAD_INIT_DATA.FAILURE:
      return state.set('loading', false);
    case types.LOADING_COMPLETE:
      return state.set('loading', false);
    case testListVDCTypes.GET_TEST_CASES.FAILURE:
      return setError(state, 'getTestCasesVDC', constants.ERROR_FAILED_LOAD_AGGREGATED_TEST_NAMES);
    case testListRDCTypes.GET_TEST_CASES.FAILURE:
      return setError(state, 'getTestCasesRDC', constants.ERROR_FAILED_LOAD_AGGREGATED_TEST_NAMES);
    case overviewVDCTypes.GET_TEST_TRENDS.FAILURE:
      return setError(state, 'getTrendsVDC', constants.ERROR_FAILED_LOAD_TEST_TRENDS);
    case overviewRDCTypes.GET_TEST_TRENDS.FAILURE:
      return setError(state, 'getTrendsRDC', constants.ERROR_FAILED_LOAD_TEST_TRENDS);
    case overviewVDCTypes.GET_AGGREGATED_TEST_ERRORS.FAILURE:
      return setError(state, 'getAggregatedTestErrorsVDC', constants.ERROR_FAILED_LOAD_ERRORS);
    case overviewRDCTypes.GET_AGGREGATED_TEST_ERRORS.FAILURE:
      return setError(state, 'getAggregatedTestErrorRDC', constants.ERROR_FAILED_LOAD_ERRORS);
    case overviewVDCTypes.GET_PAST_TRENDS.FAILURE:
      return setError(state, 'getPastTrendsVDC', constants.ERROR_FAILED_LOAD_PAST_TRENDS);
    case overviewRDCTypes.GET_PAST_TRENDS.FAILURE:
      return setError(state, 'getPastTrendsRDC', constants.ERROR_FAILED_LOAD_PAST_TRENDS);
    case testListVDCTypes.GET_TEST_CASES.SUCCESS:
      return setError(state, 'getTestCasesVDC', null);
    case testListRDCTypes.GET_TEST_CASES.SUCCESS:
      return setError(state, 'getTestCasesRDC', null);
    case overviewVDCTypes.GET_TEST_TRENDS.SUCCESS:
      return setError(state, 'getTrendsVDC', null);
    case overviewRDCTypes.GET_TEST_TRENDS.SUCCESS:
      return setError(state, 'getTrendsRDC', null);
    case overviewVDCTypes.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
      return setError(state, 'getAggregatedTestErrorsVDC', null);
    case overviewRDCTypes.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
      return setError(state, 'getAggregatedTestErrorsRDC', null);
    case overviewVDCTypes.GET_PAST_TRENDS.SUCCESS:
      return setError(state, 'getPastTrendsVDC', null);
    case overviewRDCTypes.GET_PAST_TRENDS.SUCCESS:
      return setError(state, 'getPastTrendsRDC', null);
    case types.GET_ORGANIZATION.REQUEST:
      return setError(state, 'getOrganization', null);
    case types.GET_ORGANIZATION.FAILURE:
      return setError(state, 'getOrganization', constants.ERROR_FAILED_LOAD_ORGANIZATION);
    // get test names
    default:
      return state;
  }
};

export default viewReducer;
export { initialState };
